module.exports = __webpack_public_path__ + "static/media/security1.795833a1.svg";